<h1 mat-dialog-title>Informations de debug</h1>
<div mat-dialog-content>
  <p>
    Avant de soumettre une issue sur Github :<br>
    Penser à prendre une capture d'écran du problème + intégrer les logs d'erreurs ci-dessous</p>
  <h4>Informations</h4>
  <pre>
- User-Agent : {{ userAgent }}
- Url de l'App : {{ appAppUrl }}
- Url de l'Api : {{ appApiUrl }}
- Version de l'App : {{ appVersion }}
- Environnement de l'App : {{ appEnv }}</pre>
  <h4>Logs</h4>
  <pre>{{ logs }}</pre>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-button mat-dialog-close>Fermer</button>
  <button mat-raised-button color="primary" (click)="openGithub()">
    Ouvrir une issue sur Github
    <mat-icon>open_in_new</mat-icon>
  </button>
</div>
